/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { VApplication } from "../../application";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { getAgent } from "./agent";

import {
  IGetCredentialIssuedListProps,
  RevokeCredentialProps,
} from "./components";

const is = require("is_js");

const SERVICE_NAME = "IssuedCredentialPageService";
const log: any = LoggerModule.getInstance();

export type IIssuedCredentialPageSrvGetPageContentArgs =
  IGetCredentialIssuedListProps;

export class IssuedCredentialPageService {
  private static instance: IssuedCredentialPageService;
  private vapp: VApplication;
  private criteria: any;
  private constructor(props: any = {}) {
    this.vapp = VApplication.getInstance();
  }

  public static getInstance(props: any = {}): IssuedCredentialPageService {
    if (!IssuedCredentialPageService.instance) {
      IssuedCredentialPageService.instance = new IssuedCredentialPageService(
        props
      );
    }
    return IssuedCredentialPageService.instance;
  }

  private setCriteria(data:any){
    this.criteria = data;
  }

  public resetCriteria(){
    this.criteria= null
  }

  public getStaticPageContent() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = agent.getStaticPageContentSync({});
    if (compProps) {
      content = { ...content, ...compProps };
    }
    return content;
  }

  

  public async getPageContent(
    args: IIssuedCredentialPageSrvGetPageContentArgs
  ) {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    if(args?.criteria){
      this.setCriteria(args?.criteria);
    }

    //Settings Props
    compProps = await agent.getSettingsProps({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    //UserLists Props
    compProps = await agent.getCredentialIssuedListsProps({...args, criteria:{...this.criteria, ...args?.criteria}});
    if (compProps) {
      content = { ...content, ...compProps };
    }
    return content;
  }

  public async revokeCred(args: RevokeCredentialProps) {
    console.log(`revoke credential id`, args);
    const agent = getAgent();
    return agent.getRevokeCredential(args);
  }

  public async resendCred(args: RevokeCredentialProps) {
    const agent = getAgent();
    return agent.getResendCredential(args);
  }
}
